import script from "./ChartPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChartPage.vue?vue&type=script&setup=true&lang=ts"

import "./ChartPage.vue?vue&type=style&index=0&id=a07d45aa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a07d45aa"]])

export default __exports__